<template>
    <v-container fluid tag="section" class="edit-company">
        <v-alert v-if="hasError" text prominent type="error" icon="mdi-cloud-alert">{{ error }}</v-alert>
        <v-row class="h-100">
            <v-col class="edit-company-wrapper">
                <v-progress-circular v-if="isLoading" size="40" indeterminate />
                <div v-if="hasCompany" class="list-wrapper">
                    <v-col class="left-bar-column">
                        <v-card class="list-left-bar ma-0">
                            <v-btn
                                class="ma-1 ml-0 list-section-header"
                                color="#0051ff"
                            >{{ company.title }}</v-btn>
                            <ul class="list-nav">
                                <li
                                    v-for="tab in tabs"
                                    :key="tab.id"
                                    class="list-item"
                                    :class="['tab-button', { active: currentTab === tab.id }]"
                                    @click="currentTab = tab.id"
                                >
                                    <v-icon class="mr-2">{{ tab.type }}</v-icon>
                                    {{ tab.title }}
                                </li>
                            </ul>
                        </v-card>
                    </v-col>
                    <v-col class="right-bar-column">
                        <div class="list-right-bar">
                            <v-card class="pt-0 h-100 ma-0">
                                <keep-alive>
                                    <component
                                        :is="currentTabComponent"
                                        :data="company"
                                        class="tab"
                                    />
                                </keep-alive>
                            </v-card>
                        </div>
                    </v-col>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import Profile from './company-info-tabs/CompanyProfile.vue'
    import Accounts from './company-info-tabs/CompanyAccounts.vue'
    import ClientBank from './company-info-tabs/ClientBankTab'
    import { mapGetters } from 'vuex'

    export default {
        name: 'EditCompany',

        components: {
            'tab-profile': Profile,
            'tab-accounts': Accounts,
            'tab-client-bank': ClientBank,
        },
        data: () => ({
            currentTab: 'profile',

            tabs: [
                { id: 'profile', title: 'Профиль', type: 'mdi-account' },
                { id: 'accounts', title: 'Расчетные счета', type: 'mdi-bank' },
                { id: 'client-bank', title: 'Клиент-банк', type: 'mdi-bank' },
            ],
        }),

        computed: {
            currentTabComponent() {
                return 'tab-' + this.currentTab.toLowerCase()
            },

            ...mapGetters('companies', ['company', 'isLoading', 'hasError', 'error', 'hasCompany']),
        },

        created() {
            this.$store.dispatch('companies/findById', this.$route.params.id)
        },
    }
</script>

<style lang="scss" scoped>
    .edit-company {
        &-wrapper {
            display: flex;
            padding-left: 0;
            padding-bottom: 0;

            .list-wrapper {
                display: flex;
                width: 100%;
                flex-wrap: wrap;
                padding-top: 6px;

                .left-bar-column {
                    max-width: 290px;
                    padding-bottom: 0;
                    display: flex;
                    @media (max-width: 768px) {
                        max-width: 100%;
                        flex-basis: 100%;
                    }
                }

                .right-bar-column {
                    padding-bottom: 0;
                    display: flex;
                }
            }

            .list-right-bar {
                height: 100%;
                width: 100%;
            }

            .left-bar-column {
                .list-left-bar {
                    height: 100%;
                    padding: 16px;
                    width: 100%;

                    .list-section-header {
                        position: relative;
                        top: -37px;
                        width: 100%;
                        min-height: 48px;
                        font-size: 14px;
                    }
                }
            }
        }

        .list-nav {
            padding-inline-start: 0;
            // Пункт меню
            li.list-item.tab-button {
                height: 36px;
                display: flex;
                align-items: center;
                border-radius: 6px;
                padding-left: 14px;
                cursor: pointer;
            }

            // Активный пункт меню
            li.list-item.tab-button.active {
                box-shadow: rgba(0, 0, 0, 0.14) 0 4px 20px 0,
                    rgba(76, 175, 80, 0.4) 0 7px 10px -5px;
                background-color: rgba(0, 81, 255, 0.11);
                color: #000;
            }

            li.list-item.tab-button.active
                i.v-icon.notranslate.mr-2.mdi.theme--light {
                color: #000;
            }
        }
    }
</style>
